var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsarrowleft1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.4982 16.6534C14.8928 17.0398 14.8994 17.673 14.513 18.0676C14.1563 18.4318 13.5894 18.4655 13.1939 18.1646L13.0988 18.0824L5.47187 10.6134C5.10274 10.252 5.0738 9.67582 5.38543 9.28068L5.47044 9.1859L13.0974 1.68703C13.4912 1.29983 14.1244 1.30519 14.5116 1.69901C14.869 2.06253 14.8919 2.62998 14.5836 3.01967L14.4996 3.11317L7.60002 9.89697L14.4982 16.6534Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconsarrowleft",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4982 16.6534C14.8928 17.0398 14.8994 17.673 14.513 18.0676C14.1563 18.4318 13.5894 18.4655 13.1939 18.1646L13.0988 18.0824L5.47187 10.6134C5.10274 10.252 5.0738 9.67582 5.38543 9.28068L5.47044 9.1859L13.0974 1.68703C13.4912 1.29983 14.1244 1.30519 14.5116 1.69901C14.869 2.06253 14.8919 2.62998 14.5836 3.01967L14.4996 3.11317L7.60002 9.89697L14.4982 16.6534Z",
    id: "Path-2",
    fill: "#979797",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colourambientsophia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "Rectangle-Copy-7",
    fill: "#47D5CD",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsarrowleft1X);
export default __webpack_public_path__ + "static/media/iconsarrowleft@1x.50bab022b00c25ab7d4deb8f0f6f4b5b.svg";
export { ForwardRef as ReactComponent };